export default "__VITE_ASSET__d3151fa1__"